<template>
  <div>
    <base-header class="pb-6">
      <div class="row align-items-center py-4">
        <div class="col-lg-6 col-7">
          <h6 class="h2 text-white d-inline-block mb-0">Roles</h6>
          <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div class="row justify-content-center">
        <role-form @save="saveRole" />
      </div>
    </div>
  </div>
</template>

<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb';
import RoleForm from './Forms/RoleForm';
import swal from 'sweetalert2';

export default {
  name: 'RolesCreate',
  components: {
    RoleForm,
    RouteBreadCrumb,
  },

  methods: {
    saveRole(role) {
      this.$services
        .resource('roles')
        .create(role)
        .then((res) => {
          swal({
            title: 'Listo!',
            text: 'El rol fue creado.',
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success',
            type: 'success',
          }).then(() => this.$router.push({ name: 'RolesList' }));
        });
    },
  },
};
</script>
